module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_business-hotel-c00096ffa560ef7a4a02992be01bcb56.png";